import React from 'react';
import { formatMoney } from '../utils/money';
import CurrencyBadge from './CurrencyBadge';

const TotalsByCurrency = ({ totals = {}, equivalenteArs, modoOscuro = false, className = '' }) => {
  const entries = Object.entries(totals).filter(([, v]) => Number(v) !== 0);
  if (!entries.length) return null;

  const hasForeign = entries.some(([m]) => m !== 'ARS');

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {entries.map(([moneda, total]) => (
        <span
          key={moneda}
          className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-lg border text-xs font-semibold ${
            modoOscuro ? 'border-gray-700 bg-gray-800/60' : 'border-gray-200 bg-gray-50'
          }`}
        >
          {moneda !== 'ARS' && <CurrencyBadge currency={moneda} modoOscuro={modoOscuro} size="xs" />}
          {moneda === 'ARS' && <span className={modoOscuro ? 'text-gray-400' : 'text-gray-500'}>ARS</span>}
          <span>{formatMoney(total, moneda, { showCode: moneda !== 'ARS' })}</span>
        </span>
      ))}
      {hasForeign && equivalenteArs != null && (
        <span className={`text-[11px] ${modoOscuro ? 'text-gray-400' : 'text-gray-500'}`}>
          Total ≈ {formatMoney(equivalenteArs, 'ARS')}
        </span>
      )}
    </div>
  );
};

export default TotalsByCurrency;
